import { useEffect } from "react";
import { withTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { NotFoundComponent } from "../../components/info/NotFoundComponent";
import { setShowSearch } from "../../store/appConfigsSlice";

const NotFoundPage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setShowSearch(false));
  }, [dispatch]);

  return <NotFoundComponent />;
};

export default withTranslation()(NotFoundPage);
